







import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ActivitySwitch extends Vue {
  @Prop() status!: any;
  @Prop() disabled !: boolean;

  handleSwitchStatus() {
    const newStatus = !this.status;
    this.$emit("switchStatus", newStatus);
  }
}
